import { TutorialStep } from "..";

export const AnaLabelingSteps: TutorialStep[] = [
  {
    target: "#ana-class-table",
    content: `이미지는 사전분류를 통해 앞의 단계에서 \n설정한 클래스 개수만큼으로 나뉘어집니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#ana-table-enter",
    content: "클릭하여 특정 클래스의 이미지를 확인합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#select-ai-server",
    content: "학습 진행시킬 서버를 선택해줍니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    // nextTrigger: "#image-list-panel",
    disableOverlayClose: true,
  },
  {
    target: "#image-list-panel",
    content: "앞의 단계에서 넣었던 이미지 리스트를 확인할 수 있습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#labeling-btn",
    content: `라벨링 버튼입니다. \n버튼에 써있는 숫자를 키보드에서 눌러서 라벨링을 쉽게 진행할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#labeling-btn",
    content: `키보드로 1,2,3,4를 눌러서 자유롭게 라벨링을 진행해보세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#image-list-panel",
    content: `A(1) 10장 라벨링을 진행하세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#open-train-option",
    disableOverlayClose: true,
  },
  {
    target: "#image-part",
    content: `또는 이미지의 특정 부분을 클릭하며 컨투어링을 진행할 수 있습니다.`,
    spotlightClicks: true,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#image-part",
    content: `자유롭게 클릭하여 자동 컨투어링 해보세요`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
    nextTrigger: "contour-scan-complete",
  },
  {
    target: "#image-part",
    content: `스캔된 부분에 오른쪽 마우스를 클릭하여 라벨링을 진행하세요`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
    nextTrigger: "contour-label-start",
  },
  {
    target: "#image-part",
    content: `이렇게 컨투어링을 통해 라벨링도 가능합니다`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
    nextTrigger: "contour-label-saved",
  },
  {
    target: "#open-train-option",
    content: `학습 진행버튼을 클릭해보세요`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#train-option-popover",
    content: `학습할 이미지 수를 자유롭게 조정할 수 있습니다. 학습 시작 버튼을 눌러 학습을 진행해보세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#ai-progress",
    content: `학습/검증이 진행될때 진행률을 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#image-list-panel",
    content: `검증이 진행될때는 각 이미지의 AI label과 score값을 확인할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  //TODO: 라벨 별 히트맵 확인 step 추가 필요
  {
    target: "#next-class-btn",
    content: `특정 클래스가 정제되면 다음 클래스로 이동하여 같은 작업을 반복합니다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#next-class-btn",
    content: `이후 모든 클래스에서 동일한 작업을 진행했다고 가정하고 메인 화면으로 이동합니다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#analysis-train-btn",
    content: `이제 모든 클래스에 대해 학습과 라벨링을 수행하여 전체 이미지를 정제해 보겠습니다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
